export enum CalendarNavigation {
  previous = 'previous',
  next = 'next',
  today = 'today',
}
